import {
    SET_INFO_AUTH,
    CLOSE_INFO,
    SET_IS_ADMIN,
} from '../actions/types';
const INITIAL_STATE = {
    info: '',
    status: 0,
    isAdmin: false,
};

const AuthReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_INFO_AUTH:
            return {
                ...state,
                info: action.payload.info,
                status: action.payload.status,
            }
        case SET_IS_ADMIN:
            return { ...state, isAdmin: action.payload, }
        case CLOSE_INFO:
            return {
                ...state,
                info: '',
                status: 0,
            }
        default:
            return state;
    }
};

export default AuthReducer;